/* eslint-disable no-lonely-if */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Container, BottomButton, InputBox, KeyboardContainer,
} from '../../utils/style';
import Input from '../../../../../../common/ui/Input/input';
import Keyboard from '../common/keyboard';

import { changeDictionary } from '../../../store/actions';
import store from '../../../store/store';

const { dispatch } = store;

function SelectedInput(props) {
  const {
    data, button, screenPath, styleButton, style, styleBottom, matchId, setInputId,
  } = props;
  const { dictionary } = useSelector((state) => state.ticket);
  const el = dictionary.find((dict) => dict.fid === +matchId);
  const [value, setValue] = useState(el ? el.fv : '');
  const [valuesList, setValuesList] = useState([]);
  const [showKeyboard, setShowKeyboard] = useState(true);
  const [editingIndex, setEditingIndex] = useState(-1);
  const {
    position, left, top, styleShow,
  } = styleBottom;

  // Парсинг значения с запятыми
  const parseValueWithCommas = (inputValue) => {
    if (!inputValue || !inputValue.trim()) return [];

    // Разбиваем строку по запятым и убираем пробелы
    return inputValue.split(',').map((item) => item.trim()).filter((item) => item);
  };

  // Загружаем сохраненные значения при монтировании
  useEffect(() => {
    if (button.someValues && el) {
      if (el.values && Array.isArray(el.values)) {
        // Если есть массив значений, используем его
        setValuesList(el.values);
        setShowKeyboard(false);
      } else if (el.fv) {
        // Если есть только строка с запятыми, парсим ее
        const parsedValues = parseValueWithCommas(el.fv);
        if (parsedValues.length > 0) {
          setValuesList(parsedValues);
          setShowKeyboard(false);
        }
      }
    }
  }, [button.someValues, el]);

  // Обработчик нажатия кнопки "Далее"
  const onClick = () => {
    if (!button.someValues) {
      // Обычный режим - просто отправляем значение
      dispatch(changeDictionary({
        fid: +matchId, fv: value, to: screenPath, input: true,
      }));
      setInputId(null);
    } else if (editingIndex >= 0) {
      // Режим редактирования - обновляем существующее значение или удаляем, если пустое
      if (value.trim()) {
        // Если поле не пустое, обновляем значение
        const newList = [...valuesList];
        newList[editingIndex] = value;
        setValuesList(newList);
        setValue('');
        setShowKeyboard(false);
        setEditingIndex(-1);
      } else if (valuesList.length > 1) {
        // Если поле пустое и в списке больше одного элемента, удаляем элемент
        const newList = [...valuesList];
        newList.splice(editingIndex, 1);
        setValuesList(newList);
        setValue('');
        setShowKeyboard(false);
        setEditingIndex(-1);
      } else {
        // Если поле пустое, но это единственное значение, сохраняем пустое значение и возвращаемся на предыдущий экран
        // Отправляем пустое значение и возвращаемся на предыдущий экран
        dispatch(changeDictionary({
          fid: +matchId, fv: '', to: screenPath, input: true,
        }));
        setInputId(null);
      }
    } else {
      // Режим добавления - добавляем новое значение
      if (value.trim()) {
        // Проверяем, есть ли запятые в значении
        const parsedValues = parseValueWithCommas(value);

        if (parsedValues.length > 1) {
          // Если есть запятые, добавляем все значения по отдельности
          const newList = [...valuesList, ...parsedValues];
          setValuesList(newList);
        } else {
          // Если запятых нет, добавляем как одно значение
          const newList = [...valuesList, value];
          setValuesList(newList);
        }

        setValue('');
        setShowKeyboard(false);
      }
    }
  };

  // Показываем экран ввода для добавления нового ЛС
  const showInputScreen = () => {
    setValue('');
    setEditingIndex(-1);
    setShowKeyboard(true);
  };

  // Показываем экран редактирования для существующего ЛС
  const editLS = (index) => {
    setValue(valuesList[index]);
    setEditingIndex(index);
    setShowKeyboard(true);
  };

  // Удаляем неиспользуемую функцию deleteLS, так как удаление теперь происходит через пустое поле

  // Завершение ввода нескольких значений
  const finishMultipleInput = () => {
    // Формируем строку с запятыми, если значений больше двух
    let finalValue = '';

    if (valuesList.length > 2) {
      finalValue = valuesList.join(', ');
    } else if (valuesList.length === 2) {
      finalValue = `${valuesList[0]}, ${valuesList[1]}`;
    } else if (valuesList.length === 1) {
      // eslint-disable-next-line prefer-destructuring
      finalValue = valuesList[0];
    }

    console.log(finalValue);

    dispatch(changeDictionary({
      fid: +matchId,
      fv: finalValue,
      values: finalValue,
      to: screenPath,
      input: true,
    }));
    setInputId(null);
  };

  const newStyle = { ...styleBottom };
  if (position === 'absolute') {
    newStyle.position = 'static';
  }
  if (!styleShow) {
    delete newStyle.background;
    delete newStyle.boxShadow;
    newStyle.borderWidth = 0;
  }

  // Стандартный режим ввода (someValues === false)
  if (!button.someValues) {
    return (
      <KeyboardContainer between>
        <KeyboardContainer>
          <InputBox button={style}>
            <Input
              style={style}
              key={button.id}
              item={button}
              value={value}
              id={button.params.fid}
              buttonId={button.id}
              data={data}
            />
            <Keyboard
              styleButton={styleButton}
              login={50}
              id={button.params.value}
              width={styleButton.width}
              setValue={setValue}
              value={value}
            />
          </InputBox>
        </KeyboardContainer>
        {matchId && (
          <Container style={{
            position,
            top,
            left,
            width: position === 'absolute' ? 'min-content' : '100%',
          }}
          >
            <BottomButton style={{ ...newStyle, minWidth: '150px' }} onClick={onClick}>
              <p>Далее</p>
            </BottomButton>
          </Container>
        )}
      </KeyboardContainer>
    );
  }

  // Режим ввода нескольких значений (someValues === true)
  if (showKeyboard) {
    // Экран ввода с клавиатурой
    return (
      <KeyboardContainer between>
        <KeyboardContainer>
          <InputBox button={style}>
            <Input
              style={style}
              key={button.id}
              item={button}
              value={value}
              id={button.params.fid}
              buttonId={button.id}
              data={data}
              placeholder={editingIndex >= 0 ? 'Редактировать ЛС' : 'Введите ЛС'}
            />
            <Keyboard
              styleButton={styleButton}
              login={50}
              id={button.params.value}
              width={styleButton.width}
              setValue={setValue}
              value={value}
            />
          </InputBox>
          {matchId && (
            <Container style={{
              position,
              top,
              left,
              width: position === 'absolute' ? 'min-content' : '100%',
              marginTop: '15px',
            }}
            >
              <BottomButton
                style={{ ...newStyle, minWidth: '150px' }}
                onClick={onClick}
                disabled={editingIndex < 0 && !value.trim()} // Разрешаем пустое значение при редактировании даже для единственного элемента
              >
                <p>{editingIndex >= 0 ? 'Сохранить' : 'Далее'}</p>
              </BottomButton>
            </Container>
          )}
        </KeyboardContainer>
      </KeyboardContainer>
    );
  }

  // Стили из конфига используются для отображения элементов

  // Экран с введенными значениями и кнопкой "Добавить"
  return (
    <KeyboardContainer between>
      <KeyboardContainer>
        {/* Список введенных значений */}
        {valuesList.length > 0 && (
          <div style={{ marginBottom: '20px', width: '100%' }}>
            {valuesList.map((val, index) => (
              <div
                // eslint-disable-next-line react/no-array-index-key
                key={`ls-${index}`}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '16px',
                  marginBottom: '12px',
                  background: style.background || '#fafafa',
                  borderRadius: style.borderRadius ? `${style.borderRadius}px` : '8px',
                  borderWidth: style.borderWidth ? `${style.borderWidth}px` : '2px',
                  borderColor: style.borderColor || '#d0d0d0',
                  borderStyle: 'solid',
                  boxShadow: style.boxShadow || '0 2px 6px rgba(0, 0, 0, 0.05)',
                  fontSize: style.fontSize ? `${style.fontSize}px` : '22px',
                  fontWeight: style.fontWeight || '500',
                  textAlign: style.textAlign || 'left',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  color: style.color || '#333',
                  width: style.width ? `${style.width}px` : 'auto',
                  height: style.height ? `${style.height}px` : 'auto',
                  marginTop: style.marginTop || '0',
                  marginLeft: style.marginLeft || '0',
                  marginRight: style.marginRight || '0',
                }}
                onClick={() => editLS(index)}
                tabIndex="0"
                role="button"
                aria-label={`Редактировать ЛС: ${val}`}
              >
                <span
                  style={{
                    fontWeight: style.fontWeight || '500',
                    fontSize: style.fontSize ? `${style.fontSize}px` : '22px',
                    width: '100%',
                    textAlign: 'center',
                  }}
                >
                  {val}
                </span>
              </div>
            ))}
          </div>
        )}

        {/* Кнопки управления */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <BottomButton
            style={{ ...newStyle, minWidth: '300px' }}
            onClick={showInputScreen}
          >
            <p>Добавить значение</p>
          </BottomButton>

          {valuesList.length > 0 && (
            <BottomButton
              style={{ ...newStyle, minWidth: '300px', marginLeft: '10px' }}
              onClick={finishMultipleInput}
            >
              <p>Закончить ввод</p>
            </BottomButton>
          )}
        </div>
      </KeyboardContainer>
    </KeyboardContainer>
  );
}

export default React.memo(SelectedInput);
